import React, { useState, useRef, useEffect } from 'react';
import TopNavbar from '../../components/TopNavbar';
import SideNavbar from '../../components/SideNavbar';
import { useAppSelector } from '../../redux/store';

const StudentsServices = () => {
    const [activeVideo, setActiveVideo] = useState<string | null>(null);
    const videoRef = useRef<HTMLDivElement>(null);
    const servicesData = [
        {
            heading: "Educational Loans",
            student: {
              name: "ARUN",
              email: "arun@scholarcred.com",
              phone: ""
            },
            currentStatus: "Availed",
            status: "Availed",
            video: {
              url: "https://www.youtube.com/watch?v=rlxR_skpheA",
              title: "Educational Loan Process"
            }
          },
          {
            heading: "Forex Remittance",
            student: {
              name: "ARUN",
              email: "arun@scholarcred.com",
              phone: ""
            },
            currentStatus: "Availed",
            status: "Not Availed",
            video: {
              url: "https://www.youtube.com/watch?v=6lVhNnvVMd8",
              title: "Scholarship Process"
            }
          },
          {
            heading: "Accommodations",
            student: {
              name: "ARUN",
              email: "arun@scholarcred.com",
              phone: ""
            },
            currentStatus: "Availed",
            status: "Not Availed",
            video: {
              url: "https://www.youtube.com/watch?v=7ud_EX70rLc",
              title: "Scholarship Process"
            }
          },
          {
            heading: "Travel Insurance & Ticketing",
            student: {
              name: "ARUN",
              email: "arun@scholarcred.com",
              phone: ""
            },
            currentStatus: "Availed",
            status: "Not Availed",
            video: {
              url: "https://www.youtube.com/watch?v=ZSb5dmbaAgo",
              title: "Scholarship Process"
            }
          },
    ];
    const isCollapsed = useAppSelector(state => state.sidebar.isCollapsed);
    const handleVideoPlay = (videoUrl: string) => {
        setActiveVideo(videoUrl);
        setTimeout(() => {
            const offset = 109 + 32;
            const element = videoRef.current;
            if (element) {
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }, 100);
    };

    const getYouTubeVideoId = (url: string) => {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[7].length === 11) ? match[7] : null;
    };

    const getYouTubeThumbnailUrl = (url: string) => {
        const videoId = getYouTubeVideoId(url);
        return videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : '';
    };

    const getYouTubeEmbedUrl = (url: string) => {
        const videoId = getYouTubeVideoId(url);
        return videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=1` : '';
    };

    return (
        <div className="min-h-screen bg-gray-200">
            {/* <div className="fixed top-0 left-0 w-full z-10">
                <TopNavbar />
            </div> */}
            <div className="fixed top-16 left-0 h-full z-10">
                <SideNavbar />
            </div>

            <div className={`${isCollapsed ? 'ml-[70px]' : 'ml-[290px]'} mt-[109px] p-8 transition-all duration-300`}>
                <div className="bg-white p-6 rounded-3xl w-full">
                    <div className="flex items-center gap-6 mb-6">
                        <div
                            className="flex items-center justify-center w-14 h-14 rounded-full"
                            style={{ background: 'linear-gradient(180deg, #00A6D9 10%, #3483BE 100%)' }}>
                            <img src="/images/desktop/iconoir_headset.svg" alt="Ticket Icon" className="w-8 h-8" />
                        </div>
                        <h2 className="font-montserrat text-2xl font-medium text-black">Services</h2>
                    </div>

                    {activeVideo && (
                        <div className="relative mb-8" ref={videoRef}>
                            <button
                                onClick={() => setActiveVideo(null)}
                                className="absolute -top-2 -right-2 w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-lg hover:bg-gray-100 z-10">
                                <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M1 1L13 13M1 13L13 1"
                                        stroke="#3483BE"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                    />
                                </svg>
                            </button>
                            <div className="w-full aspect-video">
                                <iframe
                                    className="w-full h-full rounded-lg"
                                    src={getYouTubeEmbedUrl(activeVideo)}
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                />
                            </div>
                        </div>
                    )}

                    {servicesData.map((service, index) => (
                        <div key={index} className="flex mb-2">
                            <div className="flex-[2] p-4 rounded-xl">
                                <h3 className="text-lg font-Montserrat font-normal mb-3">{service.heading}</h3>
                                <div className="bg-gray-100 h-24 p-3 rounded-3xl">
                                    <div className="flex justify-between items-center mb-1">
                                        <h4
                                            className="text-lg font-Montserrat font-normal px-3"
                                            style={{
                                                background: 'linear-gradient(180deg, #3483BE 0%, #02385E 100%)',
                                                WebkitBackgroundClip: 'text',
                                                WebkitTextFillColor: 'transparent'
                                            }}>
                                            {service.student.name}
                                        </h4>
                                    </div>
                                    <p className="text-xs text-gray-500 mb-1 px-3">{service.student.email}</p>
                                    <p className="text-sm text-gray-600 px-3">{service.student.phone}</p>
                                </div>
                            </div>

                            <div className="flex-1 p-4 rounded-xl">
                                <h3 className="text-lg font-Montserrat font-normal mb-3">Status</h3>
                                <div className="bg-gray-100 h-24 p-3 rounded-3xl flex items-center">
                                    <h4
                                        className="text-lg font-Montserrat font-normal  px-3"
                                        style={{
                                            background: 'linear-gradient(180deg, #3483BE 0%, #02385E 100%)',
                                            WebkitBackgroundClip: 'text',
                                            WebkitTextFillColor: 'transparent'
                                        }}>
                                        {service.status}
                                    </h4>
                                </div>
                            </div>

                            <div className="flex-1 p-4 rounded-xl">
                                <h3 className="text-lg font-Montserrat font-normal  mb-3">Watch Process</h3>
                                <div
                                    className="bg-gray-100 h-24 rounded-3xl cursor-pointer hover:bg-gray-200 transition-colors overflow-hidden"
                                    onClick={() => handleVideoPlay(service.video.url)}>
                                    <div className="relative h-full">
                                        <img
                                            src={getYouTubeThumbnailUrl(service.video.url)}
                                            alt="Video thumbnail"
                                            className="w-full h-full object-cover brightness-100"
                                        />
                                        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-10">
                                            <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-lg hover:bg-opacity-90">
                                                <div
                                                    className="ml-1"
                                                    style={{
                                                        width: 0,
                                                        height: 0,
                                                        borderTop: '8px solid transparent',
                                                        borderLeft: '12px solid #3483BE',
                                                        borderBottom: '8px solid transparent'
                                                    }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="flex-1 p-4 rounded-xl">
                                <h3 className="text-lg font-Montserrat font-normal mb-3">Current Status</h3>
                                <div className="bg-gray-100 h-24 p-3 rounded-3xl flex items-center">
                                    <h4
                                        className="text-lg font-Montserrat font-normal px-3"
                                        style={{
                                            background: 'linear-gradient(180deg, #3483BE 0%, #02385E 100%)',
                                            WebkitBackgroundClip: 'text',
                                            WebkitTextFillColor: 'transparent'
                                        }}>
                                        {service.currentStatus}
                                    </h4>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default StudentsServices;